/* Independent controller: does not change Symmetry's cart, gallery or video manager. */
(() => {
  if (customElements.get('tpac-motion')) return;
  const instances = new Set();
  const mobile = window.matchMedia('(max-width: 767px)');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const automaticAllowed = () => !reduced.matches && !navigator.connection?.saveData;
  const reconcile = () => {
    const visible = [...instances].filter(el => el.ratio >= .35);
    const candidate = visible.filter(el => !el.userPaused && (el.manual || (el.dataset.autoplay === 'true' && automaticAllowed()))).sort((a,b) => Number(b.manual)-Number(a.manual) || b.ratio-a.ratio)[0];
    instances.forEach(el => {
      const wanted = !document.hidden && el.ratio >= .35 && (!mobile.matches || el === candidate) && !el.userPaused && (el.manual || (el.dataset.autoplay === 'true' && automaticAllowed()));
      if (wanted) el.play(); else el.pause(reduced.matches && !el.manual);
    });
  };
  class TPACMotion extends HTMLElement {
    connectedCallback() {
      if (this.initialised || !this.querySelector('template[data-video-desktop]')) return;
      this.initialised = true; this.ratio = 0; this.userPaused = false; this.manual = false;
      this.button = this.querySelector('button'); this.player = this.querySelector('.tpac-motion__player');
      this.button.hidden = false;
      this.clickHandler = () => {
        if (this.video && !this.video.paused) { this.userPaused = true; this.manual = false; this.pause(); }
        else {
          if (mobile.matches) instances.forEach(el => { if (el !== this) { el.manual = false; el.pause(); } });
          this.userPaused = false; this.manual = true; this.ratio = Math.max(.35, this.ratio); this.play();
        }
      };
      this.button.addEventListener('click',this.clickHandler); instances.add(this);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => { this.ratio = entries[0].intersectionRatio; reconcile(); }, { threshold:[0,.35,.55,.75,1] });
        this.observer.observe(this);
      } // Older browsers retain the still and explicit play button.
    }
    ensureVideo() {
      if (this.video) return;
      const template = (mobile.matches && this.querySelector('[data-video-mobile]')) || this.querySelector('[data-video-desktop]');
      this.player.appendChild(template.content.cloneNode(true)); this.video = this.player.querySelector('video');
      this.video.muted = true; this.video.defaultMuted = true; this.video.loop = true; this.video.playsInline = true; this.video.controls = false; this.video.tabIndex = -1;
      this.video.addEventListener('playing', () => { if (!this.wantsPlayback || !this.isConnected) { this.video?.pause(); return; } this.classList.add('tpac-is-playing','tpac-has-frame'); this.setButton(true); });
      this.video.addEventListener('pause', () => { this.classList.remove('tpac-is-playing'); this.setButton(false); });
      this.video.addEventListener('error', () => { this.pause(true); this.userPaused = true; });
    }
    setButton(playing) {
      const label = playing ? this.dataset.pauseLabel : this.dataset.playLabel;
      this.button.setAttribute('aria-label',label);
      this.button.querySelector('[data-motion-label]').textContent = label;
      this.button.querySelector('[data-motion-icon]').textContent = playing ? 'Ⅱ' : '▶';
    }
    async play() {
      this.wantsPlayback = true;
      if (this.pending) return;
      this.ensureVideo(); if (!this.video.paused) return;
      const video = this.video; this.pending = true;
      try { await video.play(); if (!this.wantsPlayback || !this.isConnected || this.video !== video) video.pause(); }
      catch (_) { if (this.video === video) { this.classList.remove('tpac-is-playing','tpac-has-frame'); this.userPaused = true; this.setButton(false); } }
      finally { this.pending = false; }
    }
    pause(restorePoster = false) {
      this.wantsPlayback = false;
      if (this.video) this.video.pause();
      this.classList.remove('tpac-is-playing');
      if (restorePoster) this.classList.remove('tpac-has-frame');
      if (this.button) this.setButton(false);
    }
    resetSource() {
      this.pause(true); this.player?.replaceChildren(); this.video = null; this.pending = false;
    }
    disconnectedCallback() {
      instances.delete(this); this.observer?.disconnect(); this.button?.removeEventListener('click',this.clickHandler);
      this.resetSource(); this.initialised = false;
    }
  }
  customElements.define('tpac-motion',TPACMotion);
  document.addEventListener('visibilitychange',reconcile);
  mobile.addEventListener('change',() => { instances.forEach(el => el.resetSource()); reconcile(); });
  reduced.addEventListener('change',() => { instances.forEach(el => { el.manual=false; }); reconcile(); });
  navigator.connection?.addEventListener('change',reconcile);
})();
